import React from "react";
import "../App.css"; // uses shared styling

const MissionModal = ({ onClose }) => {
  return (
    <div className="popup-overlay">
      <div className="popup-box">
        <button className="popup-close" onClick={onClose}>×</button>
        <h2 className="popup-heading centered-heading">Take Control of Your Healing Journey</h2>
        <p>
        Chronic pain can leave you searching endlessly for answers — and too often, you’re left to navigate a sea of treatments without real guidance.
        </p>
        <p>
        This platform was built to change that. It brings together research-backed insights across a wide range of treatment options — and goes beyond the surface.
        </p>
        <p>
        You’ll see what actually works, what doesn’t, and the potential risks or side effects. We highlight which options are low-risk, which are invasive, what typically costs out-of-pocket, and whether insurance usually covers it.
        </p>
        <p>
        You deserve agency. You deserve to make decisions with clarity — not confusion. The more you understand your options, the more power you have to take your health into your own hands — and move forward with hope.
        </p>
        <p>
        This platform is here to help you stay informed, explore treatments at your own pace, and make sense of a complex and often overwhelming landscape. It’s about learning what’s out there — and using that knowledge to navigate chronic pain with greater clarity, confidence, and control.
        </p>
        <p>
        We're glad you're here — and we hope this helps you take the next step forward, on your terms.
        </p>
      </div>
    </div>
  );
};

export default MissionModal;
